// src/pages/OwnerTickerPage.jsx
// Owner-only page for managing the global ticker

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import OwnerTickerManager from '../components/OwnerTickerManager';

const ALLOWED_UIDS = [
  'mygxGSMYBWZd9v02Xyew6WMtYe13', // Anthony
  'uM4lKlr7SjPGFzDK064F1Dk6Aco2'  // Additional authorized user
];

const OwnerTickerPage = () => {
  const navigate = useNavigate();
  const [isOwner, setIsOwner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate('/login');
        return;
      }

      console.log('OwnerTickerPage - Checking UID:', user.uid);

      // Check if user UID is in allowed list
      if (ALLOWED_UIDS.includes(user.uid)) {
        console.log('OwnerTickerPage - Access granted');
        setIsOwner(true);
      } else {
        console.log('OwnerTickerPage - Access denied, redirecting to menu');
        navigate('/menu');
      }
      
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}>Loading...</div>
      </div>
    );
  }

  if (!isOwner) {
    return null;
  }

  return (
    <div style={styles.pageContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button
          onClick={() => navigate('/owner-dashboards')}
          style={styles.backButton}
        >
          ← Back to Dashboards
        </button>
      </div>

      {/* Main Content */}
      <div style={styles.content}>
        <OwnerTickerManager />
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
  },
  loadingContainer: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
  },
  spinner: {
    fontSize: '16px',
    color: '#6b7280',
  },
  header: {
    padding: '16px 24px',
    backgroundColor: 'white',
    borderBottom: '1px solid #e5e7eb',
  },
  backButton: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer',
  },
  content: {
    padding: '32px 24px',
    maxWidth: '800px',
    margin: '0 auto',
  },
};

export default OwnerTickerPage;
